/**
 * ThononAdvent Website
 */

import React from 'react';
import {Route, Routes, BrowserRouter} from "react-router-dom"
import StickyMenu3 from './Components/StickyMenu3/StickyMenu3.jsx';
import HomeView from './Views/HomeView.jsx';
import EventsAdminView from './Views/EventsAdminView.jsx';
import DiaryView from './Views/DiaryView.jsx';
import FooterPage from './Components/FooterPage/FooterPage.jsx';
import DailyWorshipView from './Views/DailyWorshipView.js';
import EventFormDialog from './Views/EventFormDialog.jsx';
import ProtectedRoute from './Components/ProtectedRoute/ProtectedRoute.jsx';
import BiblePageView from './Views/BiblePageView.js'

import './App.css';
import './css/ThononAdventTemplate.css'
import { useSelector } from 'react-redux';
import Modal from './Components/Modal/Modal.jsx';
import AuthentView from './Views/AuthentView';

//import { RootState } from './store'; // Adjust the import path if your store file is elsewhere

const App = () => {
  //const { dialogModal, eventModal} = useSelector((store: RootState) => store.modal);
  const { dialogModal, eventModal} = useSelector((store) => store.modal);

  //Rendering
  return (
      <BrowserRouter>
        {dialogModal.isOpen && <Modal/>}
        {eventModal.isOpen && <EventFormDialog/>}
        <div>          
          <div id="menu">
            <StickyMenu3/>
          </div>
         
          <Routes>
            <Route  path = "/eventsadmin" element={<ProtectedRoute><EventsAdminView/></ProtectedRoute>} />
            
            <Route  path = "/bibleread" element={<BiblePageView/>} />
            <Route  path = "/agenda" element={<DiaryView/>} />
            <Route path = "/dailyworship" element={<DailyWorshipView/>} />
            <Route  path = "/authent" element={<AuthentView/>} />

            <Route path = "/" element={<HomeView/>} />
          </Routes>
        </div>
        
        {/**
         * <p>session1: {session1}</p>
         * <p>session2: {session2}</p> 
         */}
        <FooterPage/>
      </BrowserRouter>        
  );
  
}

export default App;
